import * as React from 'react';
import { Controller, Toolbar, SelectList, Menu, CustomArgs } from '@tencent/workbench';
import { RowSpaceFeature } from './row-space-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { ActionType } from '@editor/src/js/constants/common-action-type';

/**
 * 水平对齐
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class RowSpaceController {
    constructor(private readonly feature: RowSpaceFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    public renderSelectList() {
        return <div onMouseDown={(event) => {
            event.preventDefault();
        }}>
            <SelectList
                selected={this.feature.getSelectedValue()}
                items={this.feature.getSelectList()}
                onChange={(val) => {
                    this.feature.onChange(val);
                }}
            />
        </div>;
    }

    @Menu(config.id + 1, 'onClick', { rowSpace: 1 })
    @Menu(config.id + 2, 'onClick', { rowSpace: 1.3 })
    @Menu(config.id + 3, 'onClick', { rowSpace: 1.5 })
    @Menu(config.id + 4, 'onClick', { rowSpace: 2 })
    @Menu(config.id + 5, 'onClick', { rowSpace: 2.5 })
    @Menu(config.id + 6, 'onClick', { rowSpace: 3 })
    public handleSubItemClick(@CustomArgs() args: { rowSpace: number }) {
        this.feature.callback(args.rowSpace);
    }

    @Menu(config.id + 1, 'shouldCheck', { rowSpace: 1 })
    @Menu(config.id + 2, 'shouldCheck', { rowSpace: 1.3 })
    @Menu(config.id + 3, 'shouldCheck', { rowSpace: 1.5 })
    @Menu(config.id + 4, 'shouldCheck', { rowSpace: 2 })
    @Menu(config.id + 5, 'shouldCheck', { rowSpace: 2.5 })
    @Menu(config.id + 6, 'shouldCheck', { rowSpace: 3 })
    public shouldCheck(@CustomArgs() args: { rowSpace: number }) {
        return this.feature.getItemValue() === args.rowSpace;
    }

    @Menu(ActionType.PARAGRAPH_MORE, 'onClick')
    public handleCustomClick() {
        this.feature.onChange('custom');
    }
}
